<form [formGroup]="siddhaYogaForm" (ngSubmit)="onSubmit()">
    <div class="step-container">
      <ng-template #labelSiddhaYoga>Teachings of Siddha Yoga</ng-template>
      <div class="step-title">Siddha Yoga Questions</div>
  
      {{siddhaYogaForm.value | json}}

      <!-- Question 1 -->
      <div class="row gx-2">
        <div class="form-group col-12 mb-3">
          <label for="inputTeachings">1. How are you studying and practising the teachings of Siddha Yoga?</label>
          <textarea
            class="form-control"
            id="inputTeachings"
            formControlName="teachings"
            rows="3"
            placeholder="Share your thoughts"
            maxlength="1000"
          ></textarea>
          <div *ngIf="submitted && siddhaYogaForm.get('teachings')?.invalid" class="text-danger">
            <div *ngIf="siddhaYogaForm.get('teachings')?.errors?.['required']">This field is required.</div>
            <div *ngIf="siddhaYogaForm.get('teachings')?.errors?.['minlength']">Minimum length is 10 characters.</div>
            <div *ngIf="siddhaYogaForm.get('teachings')?.errors?.['maxlength']">Maximum length is 1000 characters.</div>
          </div>
        </div>
      </div>
  
      <!-- Question 2 -->
      <div class="row gx-2">
        <div class="form-group col-12 mb-3">
          <label for="inputAppliedTeaching">2. Describe a specific situation where you applied a Siddha Yoga teaching to your daily life. What was the effect on the situation and your inner state?</label>
          <textarea
            class="form-control"
            id="inputAppliedTeaching"
            formControlName="appliedTeaching"
            rows="3"
            placeholder="Describe the situation and its impact"
            maxlength="1000"
          ></textarea>
          <div *ngIf="submitted && siddhaYogaForm.get('appliedTeaching')?.invalid" class="text-danger">
            <div *ngIf="siddhaYogaForm.get('appliedTeaching')?.errors?.['required']">This field is required.</div>
            <div *ngIf="siddhaYogaForm.get('appliedTeaching')?.errors?.['minlength']">Minimum length is 10 characters.</div>
            <div *ngIf="siddhaYogaForm.get('appliedTeaching')?.errors?.['maxlength']">Maximum length is 1000 characters.</div>
          </div>
        </div>
      </div>
  
      <!-- Question 3 -->
      <div class="row gx-2">
        <div class="form-group col-12 mb-3">
          <label for="inputSevaQualities">3. In performing seva at home, what qualities would you like to apply in your seva?</label>
          <textarea
            class="form-control"
            id="inputSevaQualities"
            formControlName="sevaQualities"
            rows="3"
            placeholder="Share the qualities you want to apply in seva"
            maxlength="1000"
          ></textarea>
          <div *ngIf="submitted && siddhaYogaForm.get('sevaQualities')?.invalid" class="text-danger">
            <div *ngIf="siddhaYogaForm.get('sevaQualities')?.errors?.['required']">This field is required.</div>
            <div *ngIf="siddhaYogaForm.get('sevaQualities')?.errors?.['minlength']">Minimum length is 10 characters.</div>
            <div *ngIf="siddhaYogaForm.get('sevaQualities')?.errors?.['maxlength']">Maximum length is 1000 characters.</div>
          </div>
        </div>
      </div>
  
      <!-- Question 4 -->
      <div class="row gx-2">
        <div class="form-group col-12 mb-3">
          <label for="inputLifeSituation">4. How does your present life situation support you in offering seva at home? Do you see any possible challenges with this commitment? If so, how would you overcome them?</label>
          <textarea
            class="form-control"
            id="inputLifeSituation"
            formControlName="lifeSituation"
            rows="3"
            placeholder="Describe your situation and challenges"
            maxlength="1000"
          ></textarea>
          <div *ngIf="submitted && siddhaYogaForm.get('lifeSituation')?.invalid" class="text-danger">
            <div *ngIf="siddhaYogaForm.get('lifeSituation')?.errors?.['required']">This field is required.</div>
            <div *ngIf="siddhaYogaForm.get('lifeSituation')?.errors?.['minlength']">Minimum length is 10 characters.</div>
            <div *ngIf="siddhaYogaForm.get('lifeSituation')?.errors?.['maxlength']">Maximum length is 1000 characters.</div>
          </div>
        </div>
      </div>
  
      <!-- Buttons -->
      <div class="d-flex justify-content-between">
        <div>
          <button class="btn savedraftbtn" type="button">SAVE AS DRAFT</button>
        </div>
        <div>
          <button type="button" class="prevbtn" (click)="goToBack()">PREVIOUS</button>
          <button type="submit" class="nextbtn">NEXT</button>
        </div>
      </div>
    </div>
  </form>
  